<dx-lookup #encodingLookup
  [dataSource]="encodingDataSource"
  [disabled]="isReadOnly"
  [showClearButton]="true"
  [value]="selectedEncoding"
  (onValueChanged)="encodingSelectedInternal($event)"
  [displayExpr]="displayExpr"
  [placeholder]="'Please select...'">
</dx-lookup>
@if (loadingEncodings) {
  <span>
    <img src="../../images/ajax-loader.gif" alt="Loading encodings..." /> Loading encodings...
  </span>
}